// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__Is1pq","title":"ClientInsurance_title__15Nhs","itemText":"ClientInsurance_itemText__a1eZH"};